export function Heart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M11.4375 3.9375L11.9578 4.5L12.5203 3.93844C14.0906 2.40797 16.2656 1.7114 18.4031 2.06719C21.6328 2.60531 24 5.4 24 8.67656V8.94844C24 10.8937 23.1937 12.7547 21.7687 14.0812L13.2984 21.9891C12.9469 22.3172 12.4828 22.5 12 22.5C11.5172 22.5 11.0531 22.3172 10.7016 21.9891L2.23078 14.0812C0.807656 12.7547 0 10.8937 0 8.94844V8.67656C0 5.4 2.36813 2.60531 5.59688 2.06719C7.69219 1.7114 9.90938 2.40797 11.4375 3.9375C11.4375 3.93797 11.3953 3.9375 11.4375 3.9375ZM11.9578 7.68281L9.84844 5.48906C8.83125 4.51312 7.3875 4.05 5.96719 4.28625C3.82266 4.6439 2.25 6.50156 2.25 8.67656V8.94844C2.25 10.2703 2.79891 11.5359 3.76594 12.4359L12 20.1234L20.2359 12.4359C21.2016 11.5359 21.75 10.2703 21.75 8.94844V8.67656C21.75 6.50156 20.175 4.6439 18.0328 4.28625C16.6125 4.05 15.1687 4.51312 14.1516 5.48906L11.9578 7.68281Z" />
    </svg>
  );
}
